import * as React from "react";

// material-ui
import makeStyles from "@material-ui/styles/makeStyles";
import Card from "@material-ui/core/Card";
import { CardContent, Grid } from "@material-ui/core";

import CircularProgress from "@material-ui/core/CircularProgress";
import Divider from "@material-ui/core/Divider";

// jaza-soft
import { PageFooter, PageHeader, Button, WithReduxForm, ReferenceInput, TextInput, SelectInput, BackButton, required } from "jazasoft";

// icons
import SaveIcon from "@material-ui/icons/Save";

// local
import CardHeader from "../../../components/CardHeader";
import MuiTable from "../../../components/MuiTable";
import Forbidden from "../../../components/Forbidden";

import { Scope, ResourceId } from "../../../utils/privilege";
import hasPrivilege from "../../../utils/hasPrivilege";

import useCreateEdit from "./useCreateEdit";
import { useEntityPrivilege } from "../../../hooks";

const useStyles = makeStyles(theme => ({
  content: {
    margin: theme.spacing(3)
  },
  marginVertical: {
    marginTop: "1em",
    marginBottom: "2em"
  },
  pageFooter: {
    "& > button": {
      marginRight: theme.spacing(2)
    }
  }
}));

const InvoiceEdit = props => {
  const { i18nKey, roles, hasAccess } = props;

  const { disableEdit } = useEntityPrivilege("GRN");
  const classes = useStyles();

  const { invoice, rows, columns, onSubmit, saving, onChange } = useCreateEdit({ ...props, page: "edit" });

  let ffHandleSubmit;
  const handleSubmitRef = submit => {
    ffHandleSubmit = submit;
  };

  const onSave = event => {
    ffHandleSubmit(event);
  };

  let initialValues = { ...invoice, supplierId: invoice?.supplier?.id };

  if (!hasPrivilege(roles, hasAccess, ResourceId.INVOICE, Scope.UPDATE) || disableEdit) {
    return <Forbidden history={props.history} />;
  }

  return (
    <div style={{ margin: "1em" }}>
      {/** Header Element */}
      <PageHeader title="resources.invoices.pageHeader.edit" titleArgs={{ _: "Edit Invoice" }} />

      {/* Main Content */}
      <div>
        <WithReduxForm initialValues={initialValues}>
          {() => (
            <div>
              {/* Basic Details */}
              <Card>
                <CardHeader title="Basic Details" />
                <Divider />
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={3}>
                      <ReferenceInput
                        i18nKey={i18nKey}
                        source="supplierId"
                        reference="suppliers"
                        pageSize={100}
                        validate={required()}
                        disabled={invoice.qcStarted || invoice.rollAllocated}>
                        <SelectInput fullWidth />
                      </ReferenceInput>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextInput
                        i18nKey={i18nKey}
                        source="invoiceNo"
                        fullWidth
                        validate={required()}
                        disabled={invoice.qcStarted || invoice.rollAllocated}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextInput i18nKey={i18nKey} source="erpInvoiceNo" fullWidth disabled={invoice.qcStarted || invoice.rollAllocated} />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>

              <Card style={{ marginTop: "1.5em" }}>
                <MuiTable
                  title="Fabric Item"
                  searchable
                  columns={columns}
                  rows={rows}
                  component="div"
                  editable
                  editing
                  showEditableActions
                  enableRowAddition
                  rowAddCount={1}
                  handleSubmitRef={handleSubmitRef}
                  onSubmit={onSubmit}
                  onChange={onChange}
                  fontSize={16}
                  i18nKey="resources.fabricItems.fields"
                />
              </Card>

              {/* Footer */}
              <PageFooter className={classes.pageFooter}>
                <BackButton label="Back" variant="outlined" color="primary" />
                <Button label="Save" color="primary" variant="contained" disabled={saving} onClick={onSave}>
                  <SaveIcon />
                  {saving && <CircularProgress size={20} thickness={2} />}
                </Button>
              </PageFooter>
            </div>
          )}
        </WithReduxForm>
      </div>
    </div>
  );
};

export default InvoiceEdit;
